<template>
<div>
  <b-img fluid class="bkg_img" :src="require('@/assets/images/pages/graphic-3.png')" />
  <div id="_document-public">
     <b-card
        class="h-full"
        header-bg-variant="primary">
        <template #header>
          <span class="p-0 text-white text-lg font-bold">SECURAMDATA - {{document.title ? document.title : `Documentos`}}</span>
        </template>
        <div class="pt-1">
          <div class="flex flex-col gap-1">
            <div class="_row">
              <div class="simple-content simple-editor" v-html-safe="document.description? document.description: ''"></div>
            </div>
            <div class="_row" v-if="document.id">
              <h5 class="mt-2 mb-0">{{ $t('document_subtitle_document') }}</h5>
              <vs-divider></vs-divider>
              <media-list :medias="files"
                    :show-delete="false"
                    :action-on-click="false"/>
                <div class="flex flex-row justify-end pb-1" v-if="files || files.length > 0">
                  <b-button @click="downloadAll" variant="primary">
                    <feather-icon
                    icon="DownloadIcon"
                    class="mr-50"/>
                    <span class="align-middle">{{$t('action.download_all')}}</span>
                  </b-button>
                </div>
                <div class="flex flex-row justify-center" v-if="files.length == 0 && document.id">
                  {{$t('msg_none_file')}}
                </div>
            </div>
            <div class="flex flex-row justify-center gap-4 mt-2" v-if="accessByCode && !document.id">
              <b-button variant="primary"
                        @click="openViewPromptCodeValidate">Informar token de Acesso</b-button>
            </div>
          </div>
        </div>
        <template #footer>
          <page-footer text-label="Entregue por"></page-footer>
        </template>
      </b-card>
  </div>
  <b-modal :title="$t('document_validate_token')"
           :ok-disabled="!validAccessTokenRequired"
           @ok="validateAccessCodeAndGetDocument(evt)"
           ok-only
           id="prompt-document-token">
        <template #default>
          <b-form ref="inputPromptValidateCode">
            <span class="text-sm">
              <p class="text-justify">
                Por motivos de segurança, você deve inserir o Token (código) abaixo a fim de verificar sua permissão para acessar o(s) documento(s). O código funcionará somente por 30 minutos e, se você solicitar um novo código, esse código deixará de funcionar.
              </p>
            </span>
            <validation-observer>
              <validation-provider
              #default="{ errors }"
                :name="$t('Token')"
                rules="required|min:4"
                class="flex-grow"
                slim>
                <b-form-group
                  id="input-group-1"
                  :label="$t('document_token')"
                  label-for="document_token">
                  <b-form-input
                    id="document_token"
                    v-model="access_code"
                    class="required"
                    :state="errors.length > 0 ? false:null"
                    required>
                  </b-form-input>
                  <b-form-invalid-feedback :class="[{'absolute': inline}]">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </validation-observer>
            <span class="text-sm">
              <p class="text-justify">
                O Token (código) é enviado automaticamente para o seu e-mail, ao acessar o link (endereço eletrônico) do documento compartilhado.
              </p>
              </span>
          </b-form>
        </template>
        <template #modal-ok>
          {{ $t('action.confirm') }}
        </template>
  </b-modal>

<!--
  <vs-prompt
        class="access-code-dialog"
        title="Validar token de acesso ao documento"
        cancel-text = "Cancelar"
        accept-text= "Validar"
        @cancel="validateCancel"
        @accept="validateCode"
        :is-valid="validAccessTokenRequired"
        :active.sync="viewPromptCodeDialog">
        <validation-observer ref="inputPromptValidateCode">
          <validation-provider
          #default="{ errors }"
            :name="$t('Token')"
            rules="required|min:4"
            class="flex-grow"
            slim>
            <b-form-group
              id="input-group-1"
              :label="$t('document_token')"
              label-for="document_token">
              <b-form-input
                id="document_token"
                v-model="access_code"
                class="required"
                :state="errors.length > 0 ? false:null"
                required>
              </b-form-input>
              <b-form-invalid-feedback :class="[{'absolute': inline}]">
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </validation-observer>

  </vs-prompt>
-->
</div>
</template>

<script>

import {
  BForm,
  BFormGroup,
  BRow,
  BCol,
  BLink,
  BCard,
  BCardText,
  BCardTitle,
  BCardFooter,
  BImg,
  BInputGroup,
  BFormInput,
  BButton,
  BAlert,
  VBTooltip,
  BModal,
} from 'bootstrap-vue'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, min, email, minLength } from '@validations'
import standard from '@/services/standard'
import GedService from '@/services/api/GedService'
import MediaList from '@/components/media/MediaList.vue'
import PageFooter from '@/components/PageFooter.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BInputGroup,
    BFormInput,
    BLink,
    BCard,
    BCardText,
    BCardTitle,
    BCardFooter,
    BImg,
    BButton,
    BAlert,
    VBTooltip,
    BModal,
    MediaList,
    PageFooter,
    ValidationObserver,
    ValidationProvider,

  },
  props: {
    param_encrypt: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      access_code: '',
      document : {},
      files: [],
      accessCodeValid: false,
      accessByCode: false,
      services: {
        ged: null,
      },
    }
  },
  watch: {

  },
  computed: {
    validateForm() {
      return (true)
    },
    validAccessTokenRequired(){
      return (!this._.isEmpty(this.access_code) && this.access_code.length >=4)

    }
  },
  methods: {
    valid(){
      if(this.$refs.inputPromptValidateCode){
        return this.$refs.inputPromptValidateCode.validate().then(success => {
          return success
        })
      }
      return false
    },
    sucessAlert() {

    },
    errorAlert() {
      //this.notifyWarning(this.$vs, 'Nenhum documento encontrado com os parâmetros informados!',3000)
    },
    openViewPromptCodeValidate(){
      this.access_code = ''
      this.$bvModal.show('prompt-document-token')
    },
    sendValidationAccessCode(){
      this.$vs.loading()
      this.services.ged.sendValidationAccessCode(this.param_encrypt).then(
          (data) => {
            this.accessByCode = data.access_by_code
            if(data.access_by_code){
              this.openViewPromptCodeValidate()
            }else{
              this.validateAccessCodeAndGetDocument()
            }
            console.log(data)
          },
          (error) => {this.$vs.loading.close()}
        ).finally(() => this.$vs.loading.close())
    },
    validateAccessCodeAndGetDocument(){
      this.$vs.loading()
      this.services.ged.validateDocumentAccessCode(this.param_encrypt, this.access_code).then(
          (data) => {
            this.accessCodeValid = data.access_code_valid
            if(data.access_code_valid){
              this.document = data.document
              this.files = data.document.files
            }else if(this.accessByCode){
              this.errorValidateAccesToken()
            }
          },
          (error) => {
            this.$vs.loading.close()
            //this.errorGetDocument()
          }
        ).finally(() => this.$vs.loading.close())
    },
    validateCancel(){

    },
    makeValidationAccessCode(){
       // Case access by code, document... Send accessCode in e-mail
       this.sendValidationAccessCode()

    },
    errorValidateAccesToken(){
      this.$vs.dialog({
          type: 'alert',
          color: 'warning',
          position: 'top-center',
          notClose: true,
          title: this.$t('validation'),
          acceptText: 'ok',
          text: this.$t('document.messages.enter_token'),
          accept: this.openViewPromptCodeValidate,
          close: this.openViewPromptCodeValidate,
        })
    },
    errorGetDocument(){
      this.$vs.dialog({
          type: 'alert',
          color: 'warning',
          title: 'Documento não Encontrado',
          acceptText: 'ok',
          text: 'Nenhum documento encontrado com os parâmetros informados!\n\nVerifique com o proprietário ou administrador da plataforma.',
          accept: this.redirectAccess,
        })
    },
    redirectAccess(){
       this.$router.push({
        name: 'login'
      })
    },
    downloadAll(){
      this.notifySuccess(this.$vs, 'Aguarde... processando sua solicitação!')
      this.services.ged.getFilesDownloadLink(this.param_encrypt).then(
        (data) => {
          const openTab = () => {this.$utils.browser.newTab(data.link)}
          openTab()
        },
        (error) => {
          this.notifyError(this.$vs, 'Erro! Não foi possível processar o link do download do(s) arquivo(s).')
        }
      )

      /*
      this.services.ged.downloadAll(this.param_encrypt, this.document.title+'.zip').then(
        (success) => {
          this.notifySuccess(this.$vs, 'Iniciando Download...')
        },
        (error) => {
          this.notifyError(this.$vs, 'Erro! Não foi possível iniciar o download dos arquivos.')
        }
      )
      */
    },
  },
  mounted() {
    //console.log(this.param_encrypt)

    this.makeValidationAccessCode()

  },
  beforeMount() {
    this.$vs.loading()
    const promisses = []

    //Services
    this.services.ged = GedService.build(this.$vs)

    /*
    promisses.push(
      this.services.ged.getDocumentByParamEncrypt(this.param_encrypt).then(
          (data) => {
            this.document = data
            this.files = data.files
          },
          (error) => {
            this.$vs.loading.close()
            this.errorGetDocument()
          }
        )
    )
    */

    Promise.all(promisses).then(() => {
      this.$vs.loading.close()
    })
  },
}
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/simple-content.scss';

.bkg_img {
  position: fixed;
  scale: 1.2;

  right: 0;
  bottom: 0;
}
#_document-public {
  @apply top-0 bottom-0 right-0 left-0;
  // position: absolute;
  padding: 1% 1%;
  padding-top: 3rem !important;
  @screen sm {
    padding: 1% 5%;
  };
  @screen lg {
    padding: 3% 18%;
  }
  & > .card {
    min-height: 50vh !important;

    & ._row {
      width: 100%;
    }

    & > .card-header {
      padding: 0.5rem 1.5rem;
    }
  }

  & table.b-table {
    & th, td {
      padding: 1px;
      @screen sm {
        padding: 0.72rem 2rem;
      }
    }
  }

  & .card-footer {
    padding: 0.5rem;
    @screen sm {
      padding: 1.5rem;
    }
  }
}


</style>

